(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1
  docEl.setAttribute('data-dpr', Math.round(dpr));

  function isMobileDevice() {
      var docEl = document.documentElement;
      var isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
      var isTouchSupported = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      return isMobileUA || (docEl.clientWidth <= 734 || isTouchSupported);
  }

  window.clickEvent = {
    start: isMobileDevice() ? 'touchstart' : 'mousedown',
    end: isMobileDevice() ? 'touchend' : 'mouseup'
  };


  // adjust body font size
  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (16 * dpr) + 'px'
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit () {
    var clientWidth = docEl.clientWidth;

    if(isMobileDevice()) docEl.classList.add('js-mobile');
    else docEl.classList.remove('js-mobile');

    if (clientWidth <= 734) {
        rem = clientWidth/(750/75);
    }
    else {
        var rem = Math.min(clientWidth/ 10, 165);
    }
    docEl.style.fontSize = rem + 'px';
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit();
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document))